import { InputSelect } from "@UI/InputNew";
import { useMemo } from 'react';
import s from './index.module.css';
import classNames from "classnames";

const Month = ({changeRegularity, index, month, firstField}) => {
    const optionsMonth = useMemo(()=>{
        const option = [
            {
                label: `Январь`,
                value: 1
            },
            {
                label: `Февраль`,
                value: 2
            },
            {
                label: `Март`,
                value: 3
            },
            {
                label: `Апрель`,
                value: 4
            },
            {
                label: `Май`,
                value: 5
            },
            {
                label: `Июнь`,
                value: 6
            },
            {
                label: `Июль`,
                value: 7
            },
            {
                label: `Август`,
                value: 8
            },
            {
                label: `Сентябрь`,
                value: 9
            },
            {
                label: `Октябрь`,
                value: 10
            },
            {
                label: `Ноябрь`,
                value: 11
            },
            {
                label: `Декабрь`,
                value: 12
            }
        ];
       
        return option;
    }, [])

    return (
        <>
            <InputSelect
                options={optionsMonth}
                newDesign
                value={month}
                onChange={
                    (e) => {
                        changeRegularity(index, e.target.value, firstField, 'month')
                    }
                }
                className={s.select} 
                classNameBox={classNames(s.selectBox, s.selectBoxMonth)}
                hideIcon={true}
            />
        </>
    )
}

export default Month;